export default __webpack_public_path__ + "static/media/Luanne_HTB.d7cf66f3.md";